import { render, staticRenderFns } from "./tjPage.vue?vue&type=template&id=3f6d77f9&scoped=true"
import script from "./tjPage.vue?vue&type=script&lang=js"
export * from "./tjPage.vue?vue&type=script&lang=js"
import style0 from "./tjPage.vue?vue&type=style&index=0&id=3f6d77f9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6d77f9",
  null
  
)

export default component.exports